import type { pt } from './pt'

type Translation<T> = { [K in keyof T]: T[K] extends string ? string : Translation<T[K]> }

export const es: Translation<typeof pt> = {
  app: {
    abaRadio: 'Radio',
    abaGente: 'Gente',
    abaEstacao: 'Estación',
    abaProgresso: 'Progreso',
    abaAdmin: 'Admin',
    secoes: 'Secciones',
    ouvinte: 'OYENTE',
    classe: 'CLASE',
    daProva: 'del examen',
    apelido: 'apodo',
    conectado: 'conectado',
    desconectado: 'desconectado',
    sair: 'salir',
    audioEstado: 'audio',
    audioIniciando: 'iniciando…',
    tentarNovamente: 'intentar de nuevo',
    sinalEncontradoEm: 'Señal encontrada en {freq} MHz.',
    varreduraCompleta: 'Barrido completo: no se encontró nada en esta banda.',
    noCanal: 'En el canal',
    ninguem: 'nadie',
    noAr: 'AL AIRE',
    canalVazioPre: 'Nadie en esta frecuencia. Mira en',
    canalVazioPos: 'dónde hay movimiento, o programa un encuentro.',
    ocultarMapa: 'Ocultar mapa',
    mapaDePropagacao: 'Mapa de propagación',
  },
  login: {
    titulo: 'Radioamador',
    confereEmail: 'Revisa tu correo',
    modoDev: 'Modo desarrollo',
    modoDevTexto:
      'Este servidor no envía correos, así que el enlace vino en la respuesta de la API. En producción esto sería un login abierto y no puede existir.',
    entrarComLink: 'Entrar con el enlace',
    usarOutroEmail: 'usar otro correo',
    erroEnviarLink: 'no fue posible enviar el enlace',
    linkInvalido: 'enlace inválido',
    linkEnviado: 'Enlace enviado.',
    cadastroIntro:
      'Crea tu cuenta con correo y contraseña — sin necesidad de abrir el correo ahora. El correo solo se usa de verdad si olvidas la contraseña después.',
    comoChamar: 'Cómo quieres que te llamemos',
    apelidoPlaceholder: 'TU APODO',
    cadastroHintPre: 'De 3 a 12 letras o números.',
    cadastroHintForte: 'No necesitas tener indicativo',
    cadastroHintPos:
      'para entrar: con un apodo ya puedes hablar en la Banda Ciudadana (PX) y en los servicios abiertos. El indicativo de radioaficionado llega después — aprobando nuestro examen, o comprobando la licencia que ya tienes en Anatel.',
    email: 'Correo electrónico',
    emailPlaceholder: 'tu@ejemplo.com',
    senha: 'Contraseña',
    confirmarSenha: 'Confirmar contraseña',
    criarConta: 'Crear cuenta',
    criando: 'creando…',
    jaTenhoConta: 'ya tengo cuenta',
    senhasNaoConferem: 'las contraseñas no coinciden',
    erroCriarConta: 'no fue posible crear la cuenta',
    erroServidor: 'no fue posible comunicarse con el servidor',
    recuperarIntro:
      '¿Olvidaste la contraseña? Escribe el correo registrado — te enviaremos un enlace para entrar y cambiarla.',
    receberLink: 'Recibir enlace de acceso',
    enviando: 'enviando…',
    jaTenhoSenha: 'ya tengo contraseña',
    loginLabel: 'Indicativo, apodo o correo',
    entrar: 'Entrar',
    entrando: 'entrando…',
    naoTemConta: '¿No tienes cuenta? Regístrate',
    esqueciSenha: 'Olvidé la contraseña',
    erroEntrar: 'no fue posible entrar',
    desafioInstrucao: 'Arrastra hasta sintonizar la marca — así sabemos que eres tú',
    desafioSintonizado: 'Sintonizado ✓',
    desafioCarregando: 'preparando el dial…',
    erroDesafio: 'no fue posible preparar la verificación — recarga la página',
  },
  admin: {
    carregando: 'cargando…',
    pedidosTitulo: 'Solicitudes de indicativo',
    semPedidos: 'No hay solicitudes pendientes.',
    classe: 'clase',
    aprovar: 'aprobar',
    recusar: 'rechazar',
    verDocumento: 'ver documento',
    comDocumento: 'con documento',
    semDocumento: 'sin documento',
    pedidosHint:
      'Aprobar adopta el indicativo en la cuenta y marca la licencia como verificada. La documentación llega por correo y no se guarda aquí.',
    contasTitulo: 'Cuentas',
    admin: 'ADMIN',
    loginBloqueado: 'LOGIN BLOQ.',
    txBloqueado: 'TX BLOQ.',
    ouvinte: 'oyente',
    comSenha: 'con contraseña',
    soLink: 'solo enlace',
    voce: 'tú',
    administra: 'administra',
    editar: 'editar',
    excluir: 'eliminar',
    editarTitulo: 'Editar',
    swl: 'SWL (oyente)',
    classeC: 'Clase C',
    classeB: 'Clase B',
    classeA: 'Clase A',
    indicativoApelido: 'Indicativo/apodo',
    email: 'Correo electrónico',
    redefinirSenha: 'Restablecer contraseña (deja en blanco para no cambiarla)',
    bloquearLogin: 'Bloquear inicio de sesión — la persona no puede entrar más, de ninguna forma',
    bloquearTx: 'Bloquear transmisión — sigue entrando y escuchando, solo no transmite',
    edicaoHint:
      'Si la persona está conectada ahora, el efecto es inmediato — la conexión se cae y ella se reconecta sola ya con el estado nuevo.',
    salvar: 'Guardar',
    cancelar: 'cancelar',
    excluirTitulo: 'Eliminar',
    excluirAviso:
      'Se van junto, sin poder deshacer: bitácora, créditos, compras, perfil de estación, encuentros y solicitudes de indicativo. La sesión de la persona deja de valer al instante.',
    digitePara: 'Escribe',
    paraConfirmar: 'para confirmar',
    excluirDefinitivamente: 'Eliminar definitivamente',
    erroListar: 'no fue posible listar las cuentas',
    erroExcluir: 'no fue posible eliminar',
    excluida: 'fue eliminada, con todo lo que dependía de ella.',
    erroServidor: 'no fue posible comunicarse con el servidor',
    atualizada: 'fue actualizada.',
    erroSalvar: 'no fue posible guardar',
  },
  awards: {
    titulo: 'Diplomas',
    resumoIniciados: '{iniciados} de {total} iniciados',
    faltamContagem: 'faltan {n}',
    faltamLista: 'Faltan: {lista}',
    eMaisContagem: 'y {n} más',
    completo: 'Completo',
    proximoTier: 'Próximo: {tier} — faltan {n}',
    feitosLista: 'Hechos: {lista}',
    nota:
      'El Modo Claro y los QSO importados entran en el historial, pero no cuentan para el diploma — si no, el trofeo no significaría nada.',
  },
  cwSender: {
    modoSimples: 'Simple',
    modoAvancado: 'Avanzado',
    modoChave: 'Manipulador manual',
    transmitindoSolte: 'Transmitiendo — suelta para terminar el punto o la raya',
    segureParaTransmitir: 'Mantén presionado para transmitir',
    noAr: 'AL AIRE',
    chave: 'MANIPULADOR',
    velocidade: 'Velocidad:',
    palavrasPorMinuto: 'palabras por minuto — toca para cambiar',
    finalizar: 'Finalizar',
    parar: 'Parar',
    placeholderAvancado: 'escribe — cada letra ya sale al aire',
    placeholderSimples: 'CQ CQ DE ...',
    enviar: 'Enviar',
    textoParaCW: 'Texto para enviar en CW',
    jeitoDeMandar: 'Forma de enviar:',
    toqueParaTrocar: '— toca para cambiar',
    semPrivilegio: 'sin privilegio en esta frecuencia',
    alfabetoMorse: 'Alfabeto Morse',
    enviado: 'Enviado:',
  },
  dock: {
    filtroLargo: 'Ancho',
    filtroNormal: 'Normal',
    filtroEstreito: 'Estrecho',
    filtroCW: 'CW',
    squelchDesligado: 'Apagado',
    squelchBaixo: 'Bajo',
    squelchMedio: 'Medio',
    squelchAlto: 'Alto',
    descer5: 'Bajar 5 kHz',
    descerMeio: 'Bajar medio kHz',
    subirMeio: 'Subir medio kHz',
    subir5: 'Subir 5 kHz',
    bandasAriaLabel: 'Bandas',
    canal: 'CANAL',
    modoLabel: 'Modo:',
    toqueParaTrocar: '— toca para cambiar',
    filtroFI: 'Filtro de FI:',
    squelchLabel: 'Squelch:',
    sql: 'SQL',
    chiadoLigado: 'Ruido de banda activado — toca para apagarlo y oír solo la voz',
    audioLimpo: 'Audio limpio, sin ruido — toca para reactivar el ruido de banda',
    chiado: 'Ruido',
    limpo: 'Limpio',
    parar: 'Parar',
    varrer: 'Barrer',
    semPrivilegio: 'sin privilegio en esta frecuencia',
    canalSilencioso: 'canal en silencio',
    sinalFraco: 'señal débil — la antena, la potencia o la distancia pueden estar limitando. Ajusta en Estación.',
    escalaFrequenciaAria: 'Escala de frecuencia. Arrastra para sintonizar.',
  },
  exam: {
    titulo: 'Examen Clase C',
    tecnicaEtica: 'Técnica y ética',
    legislacao: 'Legislación',
    eletronica: 'Electrónica',
    examRule: 'La aprobación exige {n}% en CADA disciplina, no en el promedio.',
    oQueVoceErrou: 'Lo que respondiste mal',
    certa: 'Correcta:',
    fazerOutraProva: 'Hacer otro examen',
    anterior: 'Anterior',
    proxima: 'Siguiente',
    entregarProva: 'Entregar examen',
    respondidasContagem: '{respondidas} de {total} respondidas',
    introPre: 'Tres disciplinas, 15 preguntas cada una, siguiendo el modelo del COER. La aprobación exige acertar 8 de 15 en',
    introForte: 'cada',
    introPos: 'disciplina — no en el promedio. Sin examen de telegrafía: la Res. 777/2025 abolió el CW obligatorio.',
    iniciarProva: 'Iniciar examen',
    erroIniciar: 'no fue posible iniciar el examen',
  },
  gente: {
    agora: 'AHORA',
    ja: 'ya',
    emMinutos: 'en {n} min',
    emHoras: 'en {n} h',
    emDia: 'en {n} día',
    emDias: 'en {n} días',
    noArAgora: 'Al aire ahora',
    vazio:
      'Nadie al aire en este momento. Programa un encuentro abajo — así es como el hobby resuelve esto desde siempre: se acuerda hora y frecuencia, y las dos personas aparecen.',
    noAr: 'al aire',
    noArPill: 'AL AIRE',
    encontrosMarcados: 'Encuentros programados',
    cancelar: 'cancelar',
    marcar: 'programar',
    vazioEncontros:
      'Nada programado todavía. Programar un encuentro es la forma más directa de convertir "¿hay alguien ahí?" en conversación.',
    convida: 'invita ·',
    ninguemConfirmou: 'nadie ha confirmado todavía',
    confirmados: 'confirmados',
    naoVouMais: 'Ya no voy',
    euVou: 'Yo voy',
    desmarcar: 'cancelar',
    sobreOQue: 'Sobre qué',
    placeholderTitulo: 'Charla del sábado',
    frequencia: 'Frecuencia (kHz)',
    modo: 'Modo',
    quando: 'Cuándo',
    recado: 'Mensaje (opcional)',
    placeholderRecado: 'Si eres novato, aparece — te ayudamos',
    marcarEncontro: 'Programar encuentro',
    marcando: 'programando…',
    erroMarcar: 'no fue posible programar',
  },
  identidade: {
    minhaIdentidade: 'Mi identidad',
    apelido: 'Apodo',
    indicativoDaProva: 'Indicativo del examen',
    indicativoOficial: 'Indicativo oficial',
    hintLivrePre: 'Con un apodo ya puedes hablar en la',
    hintLivreForte: 'Banda Ciudadana (PX)',
    hintLivrePos:
      'y en los servicios abiertos — no exige indicativo ni clase. Para las bandas de radioaficionado hay dos caminos: aprobar nuestro examen, que emite un indicativo aquí mismo, o comprobar la licencia que ya tienes.',
    hintSimulado:
      'Este indicativo fue emitido por nosotros y solo vale aquí dentro: el prefijo tiene tres letras, forma que la UIT no emite, así que nunca coincide con el de un radioaficionado real. En las bandas, vale lo mismo que uno oficial de tu clase. Si ya tienes indicativo propio, puedes reservarlo abajo.',
    hintOficial:
      'Indicativo verificado con la licencia presentada. Para cambiar de clase o de indicativo, abre una nueva solicitud.',
    trocarSenha: 'Cambiar la contraseña',
    definirSenha: 'Definir una contraseña',
    senhaAtualPlaceholder: 'contraseña actual',
    novaSenhaPlaceholder: 'contraseña nueva, 8 caracteres o más',
    senhaHint:
      'Con contraseña entras directo, sin abrir el correo cada vez. El enlace sigue funcionando — es por él que se recupera una contraseña olvidada.',
    trocarSenhaBotao: 'Cambiar contraseña',
    definirSenhaBotao: 'Definir contraseña',
    removerSenha: 'quitar la contraseña y volver a entrar solo por enlace',
    pedidoEmAnalise: 'Solicitud en análisis para',
    pedidoClasseTemplate: '(clase {classe})',
    pedidoMeio:
      'Nada cambia hasta que alguien revise el documento — sigues operando como estás ahora.',
    enviarComprovacaoTemplate: 'Envía la comprobación a {contato}.',
    documentoLabel: 'Documento (foto o PDF)',
    documentoJaEnviado: 'Documento ya enviado — reenviarlo reemplaza al anterior.',
    documentoAindaNao: 'Todavía no se envió ningún documento.',
    enviarDocumentoBotao: 'Enviar documento',
    enviandoDocumento: 'enviando…',
    documentoEnviado: 'Documento enviado.',
    erroEnviarDocumento: 'no fue posible enviar el documento',
    indicativoOficialSeu: 'Indicativo oficial que es tuyo',
    callsignPlaceholder: 'PY2ABC',
    reservarHint:
      'Reservar es para el titular. Vamos a pedir la licencia o el comprobante de COER con la clase activa, a tu nombre.',
    classeAtiva: 'Clase activa',
    pedirReserva: 'Pedir reserva del indicativo',
    abrindo: 'abriendo…',
    naoGuardamos:
      'El documento, si lo envías, se borra automáticamente algún tiempo después de la decisión — no queda guardado para siempre. Aquí solo queda la solicitud y el resultado.',
    erroAbrirPedido: 'no fue posible abrir la solicitud',
    erroServidor: 'no fue posible comunicarse con el servidor',
    erroGravar: 'no fue posible guardar',
    pronto: 'listo',
    excluirContaToggle: 'Eliminar mi cuenta',
    excluirContaAviso:
      'Se van junto, sin poder deshacer: bitácora, créditos, compras, perfil de estación, encuentros y solicitudes de indicativo. Sales al instante.',
    digiteSeuIndicativo: 'Escribe',
    paraExcluirConta: 'para confirmar',
    excluirContaBotao: 'Eliminar mi cuenta definitivamente',
    excluindoConta: 'eliminando…',
    erroExcluirConta: 'no fue posible eliminar la cuenta',
  },
  instalarApp: {
    iosInstrucao: 'Instala: toca en Compartir y luego "Agregar a pantalla de inicio".',
    outroInstrucao: 'Instala la app: pantalla completa, sin la barra del navegador.',
    instalar: 'instalar',
    dispensar: 'descartar',
  },
  logbook: {
    titulo: 'Bitácora',
    qso: 'QSO',
    paises: 'países',
    bandas: 'bandas',
    pDiploma: 'p/ diploma',
    indicativoPlaceholder: 'INDICATIVO',
    indicativoAria: 'Indicativo de la otra estación',
    rstEnviado: 'RST enviado',
    rstRecebido: 'RST recibido',
    gravar: 'Guardar',
    hintSufixo: 'banda, país y distancia los completa el servidor',
    jaHaContato: 'ya hay contacto con esta estación hoy, en esta banda y modo',
    erroGravar: 'no fue posible guardar',
    claro: 'CLARO',
    exportarADIF: 'Exportar ADIF',
    exportarHint: 'sale marcado como simulado — no lo envíes a LoTW ni eQSL',
  },
  mapView: {
    mapaIndisponivel: 'mapa no disponible:',
    dia: 'día',
    noite: 'noche',
    greyLineAgora: 'GREY LINE ahora',
    doSolEm: 'del sol en',
    min: 'min',
  },
  ptt: {
    transmitindoSolte: 'Transmitiendo. Suelta para escuchar.',
    segureParaFalar: 'Mantén presionado para hablar',
    bipe: 'PITIDO',
    noAr: 'AL AIRE',
    pttLabel: 'PTT',
    aguardeBipe: 'espera el pitido',
    desconectado: 'desconectado',
    semPrivilegio: 'sin privilegio aquí',
    toqueParaParar: 'toca para parar',
    solteParaOuvir: 'suelta para escuchar',
    toqueParaFalar: 'toca para hablar',
    segureParaFalar2: 'mantén presionado para hablar',
    toque: 'tocar',
    segurar: 'mantener',
    alternarTitle: 'Alterna entre mantener presionado y tocar para transmitir',
  },
  shack: {
    titulo: 'Estación y créditos',
    creditos: 'créditos',
    semSeguidas: 'sem. seguidas',
    creditosDisponiveis: 'créditos disponibles',
    deOndeVeio: '¿de dónde vino?',
    ocultarExtrato: 'ocultar extracto',
    sequenciaAtualSingular: 'Racha actual: 1 semana seguida',
    sequenciaAtualPlural: 'Racha actual: {n} semanas seguidas',
    semSequenciaSingular: 'Sin racha ahora — récord: 1 semana',
    semSequenciaPlural: 'Sin racha ahora — récord: {n} semanas',
    faltamParaBonus: 'faltan {n} para el próximo bono',
    ledgerVazio: 'Todavía no hay créditos. Haz un QSO.',
    eSeu: 'es tuyo.',
    erroComprar: 'no fue posible comprar',
    rig: 'Transceptores',
    antenna: 'Antenas',
    feedline: 'Cables (rollo de 20 m)',
    amplifier: 'Amplificadores',
    rotator: 'Rotores',
    tower: 'Torres y mástiles',
    filter: 'Filtros de FI',
    seu: 'TUYO',
    cr: 'cr',
    nota:
      'Todo el equipo se obtiene operando. Nada que afecte el desempeño de RF se vende con dinero real — un entorno donde quien paga se escucha mejor destruye la premisa del hobby.',
  },
  station: {
    minhaEstacao: 'Mi estación',
    bipeRoger: 'Pitido al soltar el PTT (roger)',
    bipeRogerHint:
      'Sale después de tu última palabra, con el transmisor todavía encendido. Dice "terminé, adelante" — en FM y en la PX no hay portadora audible, así que sin él nadie sabe si terminaste o solo respiraste.',
    bipeInicio: 'Pitido al presionar el PTT',
    bipeInicioHint:
      'Avisa que tu voz va a empezar. El micrófono solo se abre DESPUÉS del tono — el botón de PTT indica el momento de hablar.',
    ouvir: 'escuchar',
    ligueAudioPrevia: 'Activa el audio en la pestaña Radio para escuchar la vista previa.',
    bipeHint:
      'El pitido se transmite junto con la voz, así que recorre el mismo camino de radio: estación débil, pitido débil.',
    transceptor: 'Transceptor',
    antena: 'Antena',
    rotor: 'Rotor',
    cabo: 'Cable',
    filtroFI: 'Filtro de FI',
    nenhum: 'Ninguno',
    rotorHint: 'Requisito para equipar una antena direccional (Yagi) — sin rotor, queda bloqueada.',
    precisaRotor:
      'La antena elegida necesita rotor para poder equiparse. Compra uno en la tienda o vuelve a una antena sin ese requisito.',
    filtroHint: 'Sin accesorio, el piso de ancho es 500 Hz (o lo que la radio ya trae de fábrica).',
    alturaAntena: 'Altura de la antena (m)',
    alturaHint:
      'Hasta {max} m con lo que tienes hoy — sin torre, el techo es un mástil de tejado. La altura decide el ángulo de despegue, no la potencia.',
    torre: 'Torre',
    torreHint: 'Sin torre, el techo de altura es un mástil de tejado.',
    direcaoAntena: 'Dirección de la antena (grados, 0=Norte)',
    direcaoHint: 'Solo importa para antena direccional (Yagi) y para el dipolo (la orientación del cable).',
    comprimentoCabo: 'Longitud del cable (m)',
    caboHint: 'Un cable demasiado largo devuelve en pérdida lo que la antena ganó.',
    potencia: 'Potencia (W)',
    potenciaHint: 'Hasta {max} W con lo que tienes hoy.',
    amplificador: 'Amplificador',
    amplificadorHint: 'Sin amplificador, el techo de potencia es lo que la radio entrega por sí sola.',
    swr: 'ROE',
    swrHint: 'Un mal acoplamiento se convierte en pérdida en el cable.',
    ambienteQTH: 'Entorno del QTH',
    ambienteHint:
      'Define el piso de ruido. Escuchar es más difícil que hablar — y el entorno pesa más que la radio en esa cuenta.',
    locator: 'Locator (grid Maidenhead)',
    locatorHint:
      'Ej.: GG66oe. Un grid de 6 caracteres equivale a un área de ~5×5 km — suficiente para el motor de propagación, sin exponer tu dirección exacta.',
    qthHint: 'Cambiar de QTH tiene un período de espera de {h} h — si no, cazar diplomas sería teletransportación.',
    salvarEstacao: 'Guardar estación',
    salvando: 'guardando…',
    sucesso: 'Estación al aire con la configuración nueva.',
    erroSalvar: 'no fue posible guardar',
    erroServidor: 'no fue posible comunicarse con el servidor',
  },
  waterfall: {
    semSinal: 'sin señal',
    sinal: 'señal',
    sinais: 'señales',
    piso: 'piso',
    bandaSilenciosa: 'banda en silencio',
    zoom: 'Zoom:',
    toqueParaTrocar: '— toca para cambiar',
    farol: 'FARO',
  },
  langSelector: {
    idioma: 'Idioma',
  },
}
